import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
export const platformNames = {
	mkt: 'marketplace',
	ecc: 'Ecommerce',
	tirxs: { MX: 'Benestarx', CL: 'Tirxs', CLNARMA: 'Tirxs', CLANICX: 'Tirxs', CLGREEN: 'Tirxs', CLZUPHARMA: 'Tirxs' },
	pharol: 'pharol',
};

export const nameAdapter = (pharmacy, platform) => {
	console.log(platform)
	if (platform === platformNames.mkt) {
		return `${platformNames.mkt} ${platformNames.tirxs[Enviroment.COUNTRY]}`;
	}
	return `${platformNames.ecc} ${pharmacy === 'fanich' ? 'Anich' : pharmacy}`;
};
